module.exports = __webpack_public_path__ + "05_hair_brown.feb4728d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/05_hair_brown.png
// module id = iUog
// module chunks = 0